const HTTP_API = {
  ANALYSIS: "https://60bcehfbv7.execute-api.us-west-2.amazonaws.com/default/analysis", // s3 analysis API
  LUCC: "https://up9tz2e57j.execute-api.us-west-2.amazonaws.com/default/lucc_api", // s3 lucc API

  // STAC: "http://10.168.162.112:23456",
  // PRESET_MOSAICJSON: "http://10.168.162.112:",
  // TITILER: "http://10.168.162.112:8000",
  // DATA_PATH: "http://10.168.162.112:28001",

  // STAC: "http://34.208.154.90:23456",
  // PRESET_MOSAICJSON: "s3://titiler-mosaic-jsons/preset",
  // TITILER: "http://34.212.46.219:8000",
  // DATA_PATH: "s3://hkh-sdg",

  // STAC: "http://100.102.160.169:28000",
  // PRESET_MOSAICJSON: "/mnt/data/hkh/final/mosaic",
  // DATA_PATH: "http://100.102.160.169:28001",
  // TITILER: "http://100.102.160.169:28002",

  STAC: "http://123.249.64.65:28000",
  PRESET_MOSAICJSON: "/mnt/data/hkh/final/mosaic",
  DATA_PATH: "http://123.249.64.65:28001",
  TITILER: "http://123.249.64.65:28002",
};

export default HTTP_API;
